import type { ReactNode } from 'react'

/** 店内の札。夜の窓に重ねる暗い札（既定）と、書き込む紙の札（board--paper）の2種類 */
export function Chalkboard({
  title,
  children,
  className = '',
  as: Tag = 'section',
  titleId,
}: {
  title?: ReactNode
  children: ReactNode
  className?: string
  as?: 'section' | 'div' | 'aside'
  titleId?: string
}) {
  return (
    <Tag className={`board ${className}`} aria-labelledby={title && titleId ? titleId : undefined}>
      <div className="board__surface">
        {title && (
          <h2 className="board__title" id={titleId}>
            {title}
          </h2>
        )}
        {children}
      </div>
    </Tag>
  )
}
